import AuthenticatedController from './AuthenticatedController';
import {
  MAILCHIMP_ACCOUNTS,
  MAILCHIMP_OAUTH_URL,
  MAILCHIMP_REVOKE,
  MAILCHIMP_LISTS,
  MAILCHIMP_LIST_MERGE_FIELDS,
} from '@mm/api-routes';

export default class MailchimpController extends AuthenticatedController {
  static async getOauthUrl(redirectTo: string) {
    return super.get(MAILCHIMP_OAUTH_URL, {
      redirect_to: redirectTo,
    });
  }
  static async getAccounts(facebookPageId: number) {
    return super.get(MAILCHIMP_ACCOUNTS, {
      facebook_page_id: facebookPageId,
    });
  }
  static async getLists(id: number, offset: number) {
    return super.get(MAILCHIMP_LISTS, {
      account_id: id,
      offset,
    });
  }
  static async getListMergeFields(accountId: number, id: string) {
    return super.get(MAILCHIMP_LIST_MERGE_FIELDS, {
      account_id: accountId,
      list_id: id,
    });
  }
  static async revokeAccess(accountId: number) {
    return super.post(MAILCHIMP_REVOKE, {
      account_id: accountId,
    });
  }
}
